export default {"src":"/_next/static/media/polygon.4de125e3.svg","height":34,"width":38,"blurWidth":0,"blurHeight":0};